// PRD-030 Phase 2 — shared date formatting for the verification surfaces.
// F7a: timestamps everywhere — signed, term, per-Outcome due dates,
// evidence upload time, check run time. One formatter set so every
// surface renders the same shapes the ratified mockup uses
// ("Jul 22, 2026", "Jul 21, 2:14 PM", "16 days left").

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Date-ONLY strings ("2026-09-16", the shape /pnl uses for Outcome
// windows) parse as UTC midnight in JS, which renders as the PREVIOUS day
// in any western timezone. Treat them as local calendar dates.
export function parseDate(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(value);
}

export function fmtDate(value, { year = true } = {}) {
  if (!value) return null;
  const d = parseDate(value);
  if (Number.isNaN(d.getTime())) return null;
  return `${MONTHS[d.getMonth()]} ${d.getDate()}${year ? `, ${d.getFullYear()}` : ''}`;
}

export function fmtDateTime(value) {
  if (!value) return null;
  const d = parseDate(value);
  if (Number.isNaN(d.getTime())) return null;
  let h = d.getHours();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${h}:${m} ${ampm}`;
}

// Whole days from now until `value` (negative = past).
export function daysUntil(value) {
  if (!value) return null;
  const d = parseDate(value);
  if (Number.isNaN(d.getTime())) return null;
  return Math.ceil((d.getTime() - Date.now()) / (24 * 60 * 60 * 1000));
}

export function daysLeftLabel(value) {
  const n = daysUntil(value);
  if (n == null) return null;
  if (n < 0) return null; // past — the caller shows "closed <date>" instead
  if (n === 0) return 'due today';
  return `${n} day${n === 1 ? '' : 's'} left`;
}

// Position (0..1) of `value` between `start` and `end`, clamped.
export function timelinePosition(value, start, end) {
  const v = parseDate(value).getTime();
  const s = parseDate(start).getTime();
  const e = parseDate(end).getTime();
  if ([v, s, e].some(Number.isNaN) || e <= s) return 0;
  return Math.min(1, Math.max(0, (v - s) / (e - s)));
}
